// src/Components/Tournaments/AddEilatYear.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./AddEilatYear.css";

const API = process.env.REACT_APP_API;

const AddEilatYear = () => {
  const { slug } = useParams();
  const [tournamentId, setTournamentId] = useState(null);
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
  const fetchTournament = async () => {
    try {
      const res = await axios.get(`${API}/api/eilatTournaments/slug/${slug}`);
      setTournamentId(res.data._id);
    } catch (err) {
        toast.error("❌ טורניר לא נמצא");
        console.error(err);
    }
  };
  fetchTournament();
}, [slug]);

  const [form, setForm] = useState({
    name: "",
    year: "",
    registrationLink: "",
    facebookLink: "",
    showOnSite: true,
    showFlyer: true,
    showRegistration: true,
    showFacebook: true,
    showGallery: true,
    defaultEventId: false, // האם זו שנה ברירת מחדל
  });

  const [flyerFile, setFlyerFile] = useState(null);
  const [flyerPreview, setFlyerPreview] = useState(null);
  const [gallery, setGallery] = useState([]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const onFlyerChange = (e) => {
    const file = e.target.files[0];
    setFlyerFile(file || null);
    setFlyerPreview(file ? URL.createObjectURL(file) : null);
  };

  const onGalleryChange = (e) => {
    const files = Array.from(e.target.files || []);
    const newItems = files.map((f) => ({ file: f, src: URL.createObjectURL(f) }));
    setGallery((prev) => [...prev, ...newItems]);
  };

  const removeGalleryItem = (index) => {
    setGallery((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => formData.append(key, value));

    if (flyerFile) formData.append("flyer", flyerFile);
    gallery.filter((g) => g.file).forEach((g) => formData.append("gallery", g.file));

    if (!tournamentId) return toast.error("❌ מחכה לטעינת הטורניר...");

    try {
      await axios.post(`${API}/api/eilatTournaments/${tournamentId}/years`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("✅ השנה נוספה בהצלחה!");
      navigate(`/tournaments/${tournamentId}`);
    } catch (err) {
      console.error("שגיאה בהוספת שנה:", err);
      toast.error("❌ שמירת השנה נכשלה");
    }
  };

  return (
    <div className="tournament-form card">
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate(`/tournaments/${slug}`)} />
      </div>

      <h3>➕ הוספת שנה חדשה לטורניר אילת</h3>
      <form onSubmit={handleSubmit} className="form-grid">
        <label>שם הטורניר:
          <input type="text" name="name" value={form.name} onChange={handleChange} required />
        </label>
        
        <label>
          שנה:
          <input type="number" name="year" placeholder="2026" value={form.year || ""} onChange={handleChange} min="2023" max="2100" required />
        </label>

        <label>
          פלייר (תמונה):
          <input type="file" accept="image/*" onChange={onFlyerChange} />
          {flyerPreview && <img src={flyerPreview} alt="תצוגה מקדימה" className="preview" />}
        </label>

        <label>
          קישור להרשמה:
          <input type="text" name="registrationLink" placeholder="קישור להרשמה" value={form.registrationLink} onChange={handleChange} />
        </label>

        <label>
          קישור לפייסבוק:
          <input type="text" name="facebookLink" placeholder="קישור לפייסבוק" value={form.facebookLink} onChange={handleChange} />
        </label>

        <label>
          גלריה:
          <input type="file" accept="image/*" multiple onChange={onGalleryChange} />
          {gallery.length > 0 && (
            <div className="preview-grid">
              {gallery.map((g, i) => (
                <div key={i} className="thumb">
                  <img src={g.src} alt={`g${i}`} />
                  <button type="button" onClick={() => removeGalleryItem(i)}>
                    הסרה
                  </button>
                </div>
              ))}
            </div>
          )}
        </label>

        <div className="checkbox-group">
          <label>
            <input type="checkbox" name="showOnSite" checked={form.showOnSite} onChange={handleChange} />
            מוצג באתר
          </label>
          <label>
            <input type="checkbox" name="showFlyer" checked={form.showFlyer} onChange={handleChange} />
            פלייר
          </label>
          <label>
            <input type="checkbox" name="showRegistration" checked={form.showRegistration} onChange={handleChange} />
            כפתור הרשמה
          </label>
          <label>
            <input type="checkbox" name="showFacebook" checked={form.showFacebook} onChange={handleChange} />
            כפתור פייסבוק
          </label>
          <label>
            <input type="checkbox" name="showGallery" checked={form.showGallery} onChange={handleChange} />
            גלריה
          </label>
          <label>
            <input type="checkbox" name="defaultEventId" checked={form.defaultEventId} onChange={handleChange} />
            שנת ברירת מחדל
          </label>
        </div>

        <div className="buttons">
          <button type="submit">💾 שמור שנה</button>
          <button type="button" onClick={() => navigate(`/tournaments/${slug}`)}>
            ⬅️ חזרה
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEilatYear;
